"use client";

import * as _ from "lodash-es";
import {LegacyCampus} from "@/shared/legacyTypes/fetchCampusTypes";
import TextBody from "@/app/_components/cms/TextBody";
import {
	tuitionMonetaryValueKeys,
	tuitionValuesKeys,
} from "@/app/types/TuitionValues";

interface TuitionBodyClientProps {
	campus: LegacyCampus;
	body: any;
}

const TuitionBodyClient: React.FC<TuitionBodyClientProps> = ({
	campus,
	body,
}) => {
	const tuitionValues: Record<string, string> = _.pick(
		campus,
		tuitionValuesKeys
	);

	// If value is falsy, set it to TBD, otherwise add a dollar sign
	for (const tuitionNumericValueKey of tuitionMonetaryValueKeys) {
		tuitionValues[tuitionNumericValueKey] = parseInt(
			tuitionValues[tuitionNumericValueKey]
		)
			? `\$${tuitionValues[tuitionNumericValueKey]}`
			: "TBD";
	}

	return <TextBody components={body} variables={tuitionValues} />;
};

export default TuitionBodyClient;
